import { Routes, Route } from "react-router-dom";
import CategoryList from "./CategoryList";
import CategoryForm from "./CategoryForm";

export default function Category(){
  return (
    <div>
      <h2>Categories</h2>
      <Routes>
        <Route path="/" element={<CategoryList />} />
        <Route path="new" element={<CategoryForm />} />
        <Route path="edit/:id" element={<CategoryForm />} />
      </Routes>
    </div>
  );
}
